import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
`;

export const RadioContent = styled.div`
  display: flex;
  width: 100%;
`;

export const Label = styled.label`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;

  margin-left: 10px;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  width: 250px;
  color: #565656;
`;

export const Input = styled.input`
  width: 18px;
  height: 18px;
  margin-bottom: 2px;
  background: #ffffff;
  border: 1px solid #ff6600;
  box-sizing: border-box;
  :checked + label:before{
    background-color: red;
  }
`;
